import {RepositoryFactory} from '@/repository/RepositoryFactory';
const SettingsRepository = RepositoryFactory.get('settings');

export default {
  state: {
    settings: [],
    name: 'janaka',
  },
  mutations: {
    setSettings: (state, settings) => (state.settings = settings),
    setName: (state, name) => (state.name = name),
  },
  getters: {
    allSettings: state => state.settings,
    name: state => state.name
  },
  actions: {
    async fetchSettings ({commit}) {
      const {data} = (await SettingsRepository.getListOfSettings()).data
      commit('setSettings', data);
    },
    async updateSettings({commit}) {
      commit('setSettings', ['hello changed']);
    },
    updateName({commit}) {
      commit('setName', 'pradeep');
    }
  }
}
